module.exports = __webpack_public_path__ + "img/03.bf9d8048.png";